import React from "react";

import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const firewall = require("../../../assets/icons-pack/7.1 Frewall/ic_01_firewall.svg");
const datatraffic = require("../../../assets/icons-pack/7.1 Frewall/ic_02_datatraffic.svg");
const performance = require("../../../assets/icons-pack/7.1 Frewall/ic_03_performance.svg");
const security = require("../../../assets/icons-pack/7.1 Frewall/ic_04_security.svg");

const Firewall = () => {
    const heading = `FIREWALL`;
    const details = `Your first line of defense.`;

    const overview = [
        `DETASAD firewall is the first line of defense for your DETASAD cloud-based network and protects against malicious Internet traffic. Explore the capabilities and benefits of today’s intelligent Firewall solutions by selecting a wide range of third-party firewall applications from DETASAD’s market-place. Keep your data secure with a firewall, deep-packet inspection and routing services. Customize your firewall to connect networks within a data center, or across data centers, or let our experts manage it for you.`
    ];

    const advantages = [
        [
            `Dedicated Firewall`,
            `DETASAD Dedicated Firewall offer the convenience and affordability of comprehensive network protection from malware, viruses, spyware, worms, trojans, and more—before they enter your network—and without the complexity of building your own security package. Take full advantage of high-speed connectivity, without compromising the protection needed to stop cyberattacks.`,
            firewall
        ],
        [
            `High Performance`,
            `Choose your dedicated virtual firewall from the variety of firewalls based on your throughput requirement. The virtual firewalls available on DETASAD marketplace can support up to 9 Gbps estimated throughput for NGFW and up to 8 Gbps estimated throughput for SSL-VPN.`,
            performance
        ],
        [
            `Protected Data Traffic`,
            `Every customer account receives one or more dedicated VLANs secured by zone-based cloud firewalls that protect customer traffic.`,
            datatraffic
        ],
        [
            `Secure`,
            `Intrusion Detection (IDS), and Prevention (IPS) Systems are provided by best-in-class virtual appliances. Our firewall watches and automatically responds to Internet attacks, so you don't have to.`,
            security
        ]
    ];

    const functions = [
        [
            `Website/URL filtering (Content Filtering)`,
            [
                `DETASAD’s Firewall filters out the malicious content on the web on your behalf and protects you against attacks.`
            ]
        ],
        [
            `Intrusion Prevention Service (IPS)`,
            [
                `We believe that prevention is better than cure, and that is why DETASAD’s Firewall is equipped to detect and prevent any unauthorized intrusions.`
            ]
        ],
        [
            `Application Intelligence, Control and Real-Time Visualization`,
            [`The firewall is designed to remain active and detect any threats in real-time.`]
        ],
        [
            `Deep Packet Inspection of SSL Encrypted Sessions (DPI-SSL)`,
            [`Packets transmitted over SSL sessions are inspected for any threats.`]
        ],
        [
            `Virtual Private Networking (VPN) over SSL or IPsec`,
            [
                `DETASAD’s Firewall ensures that the VPN connection uses SSL or IPsec in order to create a secure and encrypted connection over the internet.`
            ]
        ],
        [
            `Option for Complete Redundancy`,
            [
                `We have designed a completely redundant solution for the firewall to ensure that your Cloud is never unprotected.`
            ]
        ]
    ];
    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-security"/>
            <SubNav overview={overview} advantages={advantages} functions={functions} />
            <Footer />
        </div>
    );
};

export default Firewall;
